angular.module('homebot', ['tandibar/ng-rollbar', 'ui.router', 'homebot.directives', 'homebot.filters', 'homebot.services', 'sharedservices', 'angular-chartist', 'ngCookies', 'ngAnimate', 'ngSanitize', 'appTemplateCache'])
  .config(['$stateProvider', '$urlRouterProvider', '$locationProvider', function($stateProvider, $urlRouterProvider, $locationProvider){

    $urlRouterProvider.otherwise("/");

    $stateProvider
      .state('homes', {
        url: '/:address/:homeId?preview&embedded',
        controller: 'HomebotCtrl',
        templateUrl: '/homes/templates/homes.html'
      })
      .state('homeSection', {
        url: '/:address/:homeId/:section',
        controller: 'HomebotCtrl',
        templateUrl: '/homes/templates/homes.html'
      });

      $locationProvider.html5Mode(true);
  }])

  .constant('API_VARS',{
    path: window.HB_APP_CONFIG.API_URL + 'v1',
    app:'HomebotWeb',
    mortgageTestData: '/test/data/mortgage-response.json',
    ratesTestData: '/test/data/rates-response.json'
  })

  .constant('APP_CONFIG', window.HB_APP_CONFIG)

  .config(['RollbarProvider', 'APP_CONFIG', function(RollbarProvider, APP_CONFIG) {
    if(!APP_CONFIG.ROLLBAR_ENV) return;

    RollbarProvider.init({
      accessToken: 'd601b21d78ec42e0a0d4e300c1d7933e',
      captureUncaught: true,
      captureUnhandledRejections: true,
      payload: {
        environment: APP_CONFIG.ROLLBAR_ENV,
      }
    });
  }])

  .constant('LOANTERMS', {
      FIX30YR: '30 Year Fixed',
      FIX25YR: '25 Year Fixed',
      FIX22YR: '22 Year Fixed',
      FIX20YR: '20 Year Fixed',
      FIX15YR: '15 Year Fixed',
      FIX10YR: '10 Year Fixed',
      ARM10YR: '10/1 ARM',
      ARM7YR: '7/1 ARM',
      ARM5YR: '5/1 ARM',
      ARM3YR: '3/1 ARM',
      ARM1YR: '1/1 ARM'
    })

  .constant('PRINCIPAL_PAYMENT_OPTIONS',
    Array.concat(_.range(50,1000,50), _.range(1000,3000,250), 3000)
  )

  // Add Authorization header to each request
  .config(['$httpProvider', function($httpProvider){
    $httpProvider.interceptors.push('AuthHeaderInterceptor');
  }])

  .run(['FastClick', function(FastClick){
    FastClick.attach(document.body);
  }]);
